const dates = {
	"Janeiro": "January",
	"Fevereiro": "February",
	"Março": "March",
	"Abril": "April",
	"Maio": "May",
	"Junho": "June",
	"Julho": "July",
	"Agosto": "August",
	"Setembro": "September",
	"Outubro": "October",
	"Novembro": "November",
	"Dezembro": "December"
};

const ENWords = {
	"a cada": "every",
	"Abrangência": "Coverage",
	"Abertas": "Open",
	"Ações": "Actions",
	"ações": "actions",
	"Acumulado": "Acumulated",
	"Adicionar": "Add",
	"Adição": "Addition",
	"Agora": "Now",
	"Agrupador": "Grouper",
	"agrupador": "grouper",
	"Agrupadores": "Groupers",
	"agrupadores": "groupers",
	"Ajuda": "Help",
	"Alerta": "Alert",
	"Alterar": "Change",
	"Alfanumérico":"Alphanumeric",
	"Amanhã": "Tomorrow",
	"Análise": "Analysis",
	"Andamento": "Progress",
	"Anexos": "Attachments",
	"Ano": "Year",
	"Anos": "Years",
	"Anual": "Annual",
	"Ambos": "Both",
	"Atual": "Current",
	"Apresentar": "Present",
	"Apresentação": "Presentation",
	"Aprovar": "Approve",
	"Arrastando": "Dragging",
	"Avançado":"Advanced",
	"Atualizados":"Updated",
	"até": "until",
	"Ativar": "Activate",
	"Ativo": "Active",
	"Ativos": "Active",
	"Atenção": "Attention",
	"Atrasado": "Late",
	"Atrasada": "Late",
	"Atrasadas": "Late",
	"atrasadas": "late",
	"atrasada": "late",
	"Atrasados": "Late",
	"atrasado(s)": "late",
	"atrasada(s)": "late",
	"Autoridade": "Accountable",
	"Auditoria": "Audit",
	"Auditorias": "Audits",
	"Até":"Until",
	"Área":"Area",
	"Alteração":"Update",
	"Arquivos":"Files",
	"Aviso":"Warning",
	"Banco de Dados":"Database",
	"Baixar": "Download",
	"Bloqueia": "Blocks",
	"Cadastros": "Registers",
	"Cadastrar": "Register",
	"Calendário": "Calendar",
	"Campos":"Fields",
	"Campo":"Field",
	"Cancelar": "Cancel",
	"Cancelada": "Canceled",
	"cancelada(s)": "canceled",
	"cancelamento": "cancellation",
	"Carregando": "Loading",
	"Causa": "Cause",
	"Canceladas": "Canceled",
	"canceladas": "canceled",
	"cancelada": "canceled",
	"Código": "Code",
	"Comentário": "Comment",
	"Comentários": "Comments",
	"Confirmação":"Confirmation",
	"Competitividade":"Competitiveness",
	"Compromisso":"Compromise",
	"concluído": "concluded",
	"Concluída": "Completed",
	"concluída(s)": "completed",
	"Concluídas": "Completed",
	"Concluídos": "Completed",
	"Concluída(s)": "Completed",
	"Conclusão": "Progress",
	"Consultar": "Consult",
	"Contrato": "Contract",
	"Cópia": "Copy",
	"CÓPIA": "COPY",
	"Coluna":"Column",
	"Concorda":"Agree",
	"Configurar": "Configurate",
	"Configurações": "Settings",
	"Configuração": "Settings",
	"Confirmar": "Confirm",
	"classificação": "classification",
	"Clientes": "Customers",
	"clientes": "customers",
	"colaboradores":"collaborators",
	"Consultado": "Consulted",
	"Consultados": "Consulteds",
	"Continuar":"Continue",
	"Cor":"Color",
	"Corporativo": "Corporative",
	"Data": "Date",
	"Dados":"Data",
	"de": "of",
	"do": "of",
	"Deduções": "Deductions",
	"Desabilitado": "Disabled",
	"Desativar": "Deactivate",
	"Dias": "Days",
	"dias": "days",
	"Duplicar":"Duplicate",
	"Deletar": "Delete",
	"Descrição": "Description",
	"Despesa": "Expense",
	"Despesas": "Expenses",
	"Destaca": "Highlight",
	"Delimitador":"Delimiter",
	"despesa": "expense",
	"Detalhes": "Details",
	"Diário": "Daily",
	"dia(s)": "day(s)",
	"Dimensão":"Dimension",
	"Dimensões": "Dimensions",
	"Direita":"Right",
	"Divisor":"Divider",
	"Divisão":"Division",
	"Dividendo":"Dividend",
	"Domingo": "Sunday",
	"Duração": "Duration",
	"e":"and",
	"em": "in",
	"Eficácia": "Efficiency",
	"Entrar": "Enter",
	"Empresa":"Company",
	"Empresas":"Companies",
	"Eventos":"Events",
	"Erro": "Error",
	"Escala": "Scale",
	"Esconder": "Hide",
	"Espanhol": "Spanish",
	"Estratégia":"Strategy",
	"Estratégias": "Strategies",
	"estratégico":"strategic",
	"Estratégico":"Strategic",
	"Estratégicos": "Strategic",
	"Esquerda":"Left",
	"esquerda":"left",
	"Excluir": "Delete",
	"Exclusão": "Delete",
	"Expandir/Comprimir": "Expand/Compress",
	"Explicação": "Explanation",
	"Exportar": "Export",
	"Faturamento": "Revenue",
	"Faixas":"Ranges",
	"Falha":"Failure",
	"Fase": "Phase",
	"Fato": "Fact",
	"Filtros": "Filters",
	"Finalizada": "Finished",
	"Financeira": "Financial",
	"Fim": "End",
	"Formato": "Format",
	"Fórmula": "Formula",
	"Força":"Strength",
	"Forças":"Strengths",
	"Fraqueza":"Weaknes",
	"Fraquezas":"Weaknesses",
	"Frequência": "Frequency",
	"Geral": "General",
	"Gráfico": "Chart",
	"gráfico": "chart",
	"Gráficos":"Charts",
	"gráficos": "charts",
	"Grupo": "Group",
	"Grupos": "Groups",
	"Habilitado": "Enabled",
	"Hierarquia": "Hierarchy",
	"Histórico": "History",
	"Hoje": "Today",
	"Horas": "Hours",
	"horas": "hours",
	"Identificação": "Identification",
	"Idioma": "Language",
	"Importante": "Important",
	"Importar":"Import",
	"Impostos": "Taxes",
	"Imprimir": "Print",
	"Inativo": "Inactive",
	"Incremento": "Increment",
	"Indicador": "Indicator",
	"Indicadores": "Indicators",
	"Indivídual": "Individual",
	"Informado": "Informed",
	"Informados": "Informeds",
	"Inteiros": "Integer",
	"Importância":"Importancy",
	"Intensidade":"Intensity",
	"Inglês": "English",
	"Início" : "Start",
	"Iniciativa": "Initiative",
	"Iniciativas": "Initiatives",
	"Inserção":"Insert",
	"Instruções": "Instructions",
	"Integração":"Integration",
	"Integrações": "Integrations",
	"Ir": "Go",
	"Itálico":"Italic",
	"itens": "items",
	"Itens": "Items",
	"Lista":"Agenda",
	"Legenda": "Subtitle",
	"Liberado": "Released",
	"liberado": "released",
	"Linha":"Line",
	"lista": "list",
	"Lixeira": "Recycle bin",
	"Matriz":"Matrix",
	"Mapas": "Maps",
	"Média":"Average",
	"Mensal": "Monthly",
	"Mensais": "Monthly",
	"Manutenção": "Maintenance",
	"Mês": "Month",
	"Meses": "Months",
	"Meta": "Goal",
	"Metas":"Goals",
	"Métricas":"Metrics",
	"Minutos": "Minutes",
	"minutos": "minutes",
	"Missão": "Mission",
	"Mensagens":"Messages",
	"Mostrando": "Showing",
	"Mostra": "Show",
	"Mostrar": "Show",
	"Mover": "Move",
	"Motivo": "Reason",
	"Multiplicação":"Multiplication",
	"Não": "No",
	"Nível": "Level",
	"Nome": "Name",
	"Normas":"Standards",
	"Norma":"Standard",
	"Números": "Numbers",
	"Negrito":"Bold",
	"Nenhuma": "None",
	"Notificações": "Notifications",
	"Numérico": "Numeric",
	"Objetivo": "Objective",
	"Objetivos": "Objectives",
	"Observação":"Observation",
	"obtido": "obtained",
	"Operadores": "Operators",
	"Opções":"Options",
	"Ocorrência": "Occurrence",
	"Ocorrências": "Occurrences",
	"Ocultar": "Hide",
	"Operação":"Operation",
	"operacional":"operational",
	"Operacional":"Operational",
	"Operacionais": "Operational",
	"Onde": "Where",
	"Ontem":"Yesterday",
	"Orçamento": "Budget",
	"Orçamentos": "Budgets",
	"Ordenar": "Order",
	"Origem": "Origin",
	"Origens": "Origins",
	"ou":"or",
	"Padrão": "Standard",
	"padrão": "standard",
	"páginas": "pages",
	"Para": "To",
	"Parâmetro":"Parameter",
	"Parâmetros":"Parameters",
	"Parcial":"Partial",
	"Participantes":"Participants",
	"Painel":"Panel",
	"para": "to",
	"Parenteses":"Parenthesis",
	"Percentual": "Percentage",
	"Período": "Period",
	"Períodos": "Periods",
	"Permite": "Allows",
	"Perspectiva": "Perspective",
	"Perspectivas": "Perspectives",
	"Presente":"Present",
	"Peso": "Weight",
	"Pesquisar": "Search",
	"Por quê": "Why",
	"Pontuação":"Score",
	"Português": "Portuguese",
	"Postergação": "Postponement",
	"postergação": "postponement",
	"Postergar": "Postpone",
	"Posterior": "Later",
	"Pontos":"Points",
	"postergar": "postpone",
	"Prefixo": "Prefix",
	"Proximo":"Next",
	"Premissas": "Premisses",
	"Previsto": "Predicted",
	"Previsão":"Prediction",
	"Principais": "Main",
	"Programa": "Program",
	"Projeto": "Project",
	"Projetos": "Projects",
	"Processo":"Process",
	"Próximo": "Next",
	"Público":"Public",
	"Quarta": "Wednesday",
	"Quinta": "Thursday",
	"Rascunho": "Draft",
	"Rastreabilidade": "Traceability",
	"Reabrir": "Reopen",
	"Realizado": "Accomplished",
	"Recarregar": "Reload",
	"Receita": "Revenue",
	"Reais": "Real",
	"receita": "revenue",
	"Recorrência": "Recurrence",
	"Recorrências": "Recurrences",
	"Registrar": "Register",
	"rejeitar": "reject",
	"Remover": "Remove",
	"Reprovar": "Reject",
	"Reprovadas": "Disapprove",
	"Resultado":"Result",
	"Responsável": "Responsible",
	"Resposta": "Answer",
	"Restaurar" : "Restore",
	"Reunião": "Meeting",
	"Reuniões": "Meetings",
	"Risco": "Risk",
	"Riscos": "Risks",
	"Relatório": "Report",
	"Relatórios": "Reports",
	"Rótulo":"Label",
	"R$": "$",
	"SWOT": "SWOT",
	"Subtração": "Subtraction",
	"RACI": "RAM Matrix",
	"Sábado": "Saturday",
	"Sair": "Exit",
	"Sala":"Room",
	"Salas": "Rooms",
	"Salvar": "Save",
	"Segunda": "Monday",
	"Selecione": "Select",
	"Semanal": "Weekly",
	"Semanas": "Weeks",
	"semana(s)": "week(s)",
	"Semana": "Week",
	"Senha": "Password",
	"sócios":"partners",
	"Somar": "Sum",
	"Subtrair": "Subtract",
	"Sexta": "Friday",
	"Sim": "Yes",
	"Situação": "Situation",
	"Suas": "Yours",
	"Subação": "Subaction",
	"subação": "subaction",
	"Subações": "Subactions",
	"subações": "subactions",
	"Soma":"Sum",
	"Sucesso": "Success",
	"Sugestões": "Suggestions",
	"Tabulação":"Tab",
	"Tarefa": "Task",
	"tático":"tactic",
	"Tático":"Tactic",
	"Táticos": "Tactics",
	"Tamanho": "Size",
	"Tendência": "Tendency",
	"Terça": "Tuesday",
	"Tempo":"Time",
	"Tipo": "Type",
	"Tipos": "Types",
	"Título": "Title",
	"Todos": "All",
	"Total": "Total",
	"Totais": "Totals",
	"Tratamento": "Treatment",
	"Tudo": "All",
	"Unitário": "Unitary",
	"Urgente": "Urgent",
	"Usuário": "User",
	"Usuários": "Users",
	"Urgência":"Urgency",
	"Valor": "Value",
	"Valores": "Values",
	"Ver": "See",
	"Visualizar": "Visualize",
	"Vírgula":"Comma",
	"Voltar": "Go back",
	"Validade":"Expiration",
	"Vinculos":"links",
	...dates
};

export default ENWords;
